var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"bg-transparent border-0 hover:bg-star-dust-200 rounded-circle h-30 w-30",on:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{attrs:{"icon":['fat', 'file-pdf']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }